import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AppMainComponent } from 'src/app/app.main.component';


@Injectable({
  providedIn: 'root'
})
export class LocationsService {

  constructor(private http: HttpClient, private app: AppMainComponent) { }


  getAllWarehouse(pageNo, pageSize, groupId, filters, isActive, searchValue, searchColumn, sortBy, isAscending) {
    let params = new HttpParams();
    params = (!pageNo ? params : params.append('PageNumber', pageNo))
    params = (!pageSize ? params : params.append('PageSize', pageSize))
    params = (!isAscending ? params : params.append('IsAscending', isAscending))
    params = params.append('isActive', isActive)
    params = (!sortBy ? params : params.append('SortBy', sortBy))
    params = (!groupId ? params : params.append('groupId', groupId))
    params = (!searchColumn ? params : params.append('SearchColumns', searchColumn))
    params = (!searchValue ? params : params.append('SearchValue', searchValue))
    params = (!filters ? params : params.append('filter', filters))
    return this.http.get<any>(`${environment.inventoryURl}Warehouse`, { observe: 'response', params })
      .toPromise()
      .then(res => ({
        wareHouses: res.body,
        headers: JSON.parse(res.headers.get('x-pagination')) //{TotalCount: 91, PageSize: 10, CurrentPage: 1, TotalPages: 10, HasNext: true, HasPrevious: false});
      }))
  }

  getAllWarehouseStock(wareHouseId, pageNumber, pageSize, isAscending, sortBy, searchColumn, searchValue) {

    let params = new HttpParams();
    params = (!pageNumber ? params : params.append('pagenumber', pageNumber))
    params = (!pageSize ? params : params.append('pagesize', pageSize))
    params = (!isAscending ? params : params.append('isascending', isAscending))
    params = (!sortBy ? params : params.append('sortby', sortBy))
    params = (!wareHouseId ? params : params.append('id', wareHouseId))
    params = (!searchColumn ? params : params.append('searchcolumns', searchColumn))
    params = (!searchValue ? params : params.append('searchvalue', searchValue))

    return this.http.get<any>(`${environment.inventoryURl}Warehouse/WarehouseStockDetailsById`, { observe: 'response', params })
      .toPromise()
      .then(res => ({
        stockList: res.body,
        headers: JSON.parse(res.headers.get('x-pagination')) //{TotalCount: 91, PageSize: 10, CurrentPage: 1, TotalPages: 10, HasNext: true, HasPrevious: false});
      }))
  }

  getAllBin(wareHouseId, pageNumber, pageSize, isAscending, sortBy, searchColumn, searchValue, filter, allBins) {
    let params = new HttpParams();
    params = (!pageNumber ? params : params.append('PageNumber', pageNumber))
    params = (!pageSize ? params : params.append('PageSize', pageSize))
    params = (!isAscending ? params : params.append('IsAscending', isAscending))
    params = (!sortBy ? params : params.append('SortBy', sortBy))
    params = (!wareHouseId ? params : params.append('warehouseId', wareHouseId))
    params = (!searchColumn ? params : params.append('SearchColumns', searchColumn))
    params = (!searchValue ? params : params.append('SearchValue', searchValue))
    params = (!filter ? params : params.append('filter', filter))
    params = params.append('showallbins', allBins)

    return this.http.get<any>(`${environment.inventoryURl}WarehouseBin`, { observe: 'response', params })
      .toPromise()
      .then(res => ({
        binList: res.body,
        headers: JSON.parse(res.headers.get('x-pagination')) //{TotalCount: 91, PageSize: 10, CurrentPage: 1, TotalPages: 10, HasNext: true, HasPrevious: false});
      }))
  }

  getAllTransfers(wareHouseId, pageNumber, pageSize) {
    let params = new HttpParams();
    params = (!pageNumber ? params : params.append('PageNumber', pageNumber))
    params = (!pageSize ? params : params.append('PageSize', pageSize))
    params = (params.append('IsAscending', 'false'))
    params = (params.append('SortBy', 'CreatedDate'))
    params = (!wareHouseId ? params : params.append('warehouseId', wareHouseId))

    return this.http.get<any>(`${environment.inventoryURl}InventoryTransfer`, { observe: 'response', params })
      .toPromise()
      .then(res => ({
        transferList: res.body,
        headers: JSON.parse(res.headers.get('x-pagination')) //{TotalCount: 91, PageSize: 10, CurrentPage: 1, TotalPages: 10, HasNext: true, HasPrevious: false});
      }))
  }

  getAllAdjustments(wareHouseId, pageNumber, pageSize) {
    let params = new HttpParams();
    params = (!pageNumber ? params : params.append('PageNumber', pageNumber))
    params = (!pageSize ? params : params.append('PageSize', pageSize))
    params = (params.append('IsAscending', 'false'))
    params = (params.append('SortBy', 'CreatedDate'))
    params = (!wareHouseId ? params : params.append('warehouseId', wareHouseId))

    return this.http.get<any>(`${environment.inventoryURl}InventoryAdjustment`, { observe: 'response', params })
      .toPromise()
      .then(res => ({
        adjustmentList: res.body,
        headers: JSON.parse(res.headers.get('x-pagination')) //{TotalCount: 91, PageSize: 10, CurrentPage: 1, TotalPages: 10, HasNext: true, HasPrevious: false});
      }))
  }

  getAttnContactLost(search) {
    const searchData = encodeURIComponent(search);
    return this.http.get<any>(
      `${environment.appOrgUrl}User/UsersWithName?search=${searchData}`
    );
  }

  getTransferDataById(id): Observable<any> {
    return this.http.get<any>(`${environment.inventoryURl}InventoryTransfer/${id}`);
  }

  getAdjustmentDataById(id): Observable<any> {
    return this.http.get<any>(`${environment.inventoryURl}InventoryAdjustment/${id}`);
  }

  getAllGroups(parentGroupId?) {
    let params = new HttpParams();
    params = (parentGroupId ? params.append('parentGroupId', parentGroupId) : params)
    return this.http.get<any>(`${environment.coreUrl}Group`, { params: params });
  }

  getWarehouseConfigurations(name): Observable<any> {
    return this.http.get<any>(`${environment.configUrl}Configuration/ConfigurationsByModuleName?name=${name}`);
  }

  getWarehouseStatus(id): Observable<any> {
    return this.http.get<any>(`${environment.inventoryURl}Warehouse/CheckWarehouseProductExist?warehouseId=${id}`);
  }

  getWarehouseQBStatus(id): Observable<any> {
    return this.http.get<any>(`${environment.inventoryURl}Warehouse/CheckWarehouseQBExist?warehouseId=${id}`);
  }

  deleteWarehouse(id) {
    return this.http.delete<any>(`${environment.inventoryURl}Warehouse/${id}`)
      .toPromise()
      .then(res => res);
  }

  getAllCategory(groupId) {
    return this.http.get<any>(`${environment.inventoryURl}Category?groupId=${groupId}`);
  }

  getAllGroupTypes(groupId) {
    return this.http.get<any>(`${environment.inventoryURl}Type?groupId=${groupId}`);
  }

  getAllFinancialAccounts() {
    return this.http.get<any>(`${environment.financeURl}FinancialAccount/GetFinancialAccounts`);
  }

  getAddressTypes() {
    return this.http.get<any>(`${environment.coreUrl}Address/AddressType`);
  }


  getCountry() {
    return this.http.get<any>(`${environment.coreUrl}Country`);
  }

  getLocationById(id) {
    return this.http.get<any>(`${environment.inventoryURl}Warehouse/${id}`);
  }

  getAllStates(countryId: number) {
    return this.http.get<any>(`${environment.coreUrl}State`, {
      params: new HttpParams().append("countryId", countryId.toString())
    })
      .toPromise()
      .then(res => res);
  }

  getAllCities(stateId) {
    return this.http.get<any>(`${environment.coreUrl}City`, {
      params: new HttpParams().append("stateId", stateId.toString())
    })
      .toPromise()
      .then(res => res);
  }

  updateBin(data) {
    return this.http.put<any>(`${environment.inventoryURl}WarehouseBin`, data)
      .toPromise()
      .then(res => res);
  }

  addLocation(data) {
    return this.http.post<any>(`${environment.inventoryURl}Warehouse`, data)
      .toPromise()
      .then(res => res);
  }


  updateLocation(data): Observable<any> {
    return this.http.put<any>(`${environment.inventoryURl}Warehouse`, data)
      .pipe(
        tap(val => {
          // this.addLog(val,'put',`${environment.inventoryURl}Warehouse`).subscribe(res=> {
          // })
        })
      )
  }

  addLog(data, methodType, apiUrl): Observable<any> {
    const req = {
      id: 0,
      createdSource: this.app.userIP,
      updatedSource: this.app.userIP,
      createdBy: this.app.userId,
      updatedBy: this.app.userId,
      createdDate: new Date().toISOString(),
      updatedDate: new Date().toISOString(),
      organizationId: this.app.companyId,
      requestJson: JSON.stringify(data),
      apiUrl: apiUrl,
      requestType: methodType
    }

    return this.http.post<any>(`${environment.inventoryURl}Logging`, req);
  }




  addLocationGroup(data) {
    return this.http.post<any>(`${environment.coreUrl}Group`, data)
      .toPromise()
      .then(res => res);
  }

  addBin(data) {
    return this.http.post<any>(`${environment.inventoryURl}BinSection`, data)
      .toPromise()
      .then(res => res);
  }

  getInventoryTransferWarehouse() {
    //return this.http.get<any>(`${environment.inventoryURl}Warehouse/WarehouseWithName`);
    let params = new HttpParams();
    params = params.append('PageNumber', '0')
    params = params.append('PageSize', '0')
    params = params.append('SearchValue', '')
    return this.http.get<any>(`${environment.inventoryURl}WareHouse/AllWarehouseDetails`, { params });
  }

  getInventoryTransferProducts(warehouseId, search) {
    let params = new HttpParams();
    params = params.append('search', search)
    return this.http.get<any>(`${environment.inventoryURl}Product/GetWarehouseWiseProduct?typeId=1&warehouseId=${warehouseId}&PageNumber=1&PageSize=100`, { params });
  }

  getInventoryAdjustmentProducts(warehouseId, search, showallProducts) {
    let params = new HttpParams();
    params = !showallProducts ? params : params.append('allProducts', true)
    params = params.append('search', search)
    return this.http.get<any>(`${environment.inventoryURl}Product/GetWarehouseWiseProductForAdjustment?typeId=1&warehouseId=${warehouseId}&PageNumber=0&PageSize=100`, { params });
  }

  getInventoryTransferBins(warehouseId, productId, isSource, fromAdjustment, allProducts?) {
    let params = new HttpParams();
    params = (allProducts ? params.append('allProducts', true) : params)
    params = (fromAdjustment ? params.append('isAdjustment', true) : params)
    return this.http.get<any>(`${environment.inventoryURl}WarehouseBin/ProductWarehouseWiseBins?warehouseId=${warehouseId}&productId=${productId}&IsSource=${isSource}&PageNumber=0&PageSize=0`, { params });
  }

  addInventoryTransfer(data) {
    return this.http.post<any>(`${environment.inventoryURl}InventoryTransfer`, data).toPromise()
      .then(res => res);
  }

  addInventoryAdjust(data) {
    return this.http.post<any>(`${environment.inventoryURl}InventoryAdjustment`, data).toPromise()
      .then(res => res);
  }

  addState(data: object) {
    return this.http.post<any>(`${environment.coreUrl}State`, data)
      .toPromise()
      .then(res => res);
  }

  addCity(data: object) {
    return this.http.post<any>(`${environment.coreUrl}City`, data)
      .toPromise()
      .then(res => res);
  }

  checkIsDuplicateLocation(locationId, warehouseId) {
    let params = new HttpParams();
    params = params.append('locationId', locationId)
    params = params.append('warehouseId', warehouseId)
    return this.http.get<any>(`${environment.inventoryURl}Warehouse/CheckIsDuplicateLocationId`, { params });
  }

  generateSerialNo(length) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
  }

  getOrganizationTypes(groupName): Observable<any> {
    return this.http.get<any>(`${environment.appOrgUrl}Type?groupName=${groupName}`);
  }

  getCategoryGroups(groupName): Observable<any> {
    return this.http.get<any>(`${environment.appOrgUrl}Category/GetAllCategoryByGroup?groupName=${groupName}`);
  }

  checkSerialNoInSystem(warehouseId, productId) {
    return this.http.get<any>(`${environment.inventoryURl}Product/SerialListForOrders?productId=${productId}&warehouseId=${warehouseId}`);
  }

  checkSystemTrackingData(productId,warehouseId,billId,refField,dataString,isVendorRMA){
    let params = new HttpParams();
    params =  (!billId ? params : params.append('billId', billId))
    params =  params.append('productId', productId);
    params =  params.append('warehouseId', warehouseId);
    params = (!refField ? params : params.append('referenceId', refField) )
    params = (!isVendorRMA ? params : params.append('isVendorRMA', isVendorRMA) )
    return this.http.post<any>(`${environment.inventoryURl}Product/CheckSerialForView`, dataString, {params});
  }

  getAllInventorySettings(): Observable<any> {
    return this.http.get<any>(`${environment.inventoryURl}Product/InventorySettings`)
  }

  loadTrackingOptions(): Observable<any> {
    return this.http.get<any>(`${environment.inventoryURl}TrackingSetting`);
  }

  checkSerialNoInAllSystem(serialNo, warehouseId, productId, isAdjustment: boolean, isIncrease: boolean): Observable<any> {
    let params = new HttpParams();
    params = params.append('isAdjustment', isAdjustment)
    params = params.append('isIncrease', isIncrease)
    return this.http.get<any>(`${environment.inventorySalesUrl}Serial/CheckSerialAssociation?serial=${serialNo}&productIds=${productId}&warehouseId=${warehouseId}`, { params });
  }

  checkSerialNoInAllSystemInvTransfer(serialNo, fromWarehouseId, toWarehouseId, productId): Observable<any> {
    let params = new HttpParams();
    params = params.append('fromWarehouseId', fromWarehouseId)
    params = params.append('toWarehouseId', toWarehouseId)
    return this.http.get<any>(`${environment.inventorySalesUrl}Serial/CheckSerialAssociationForTransfer?serial=${serialNo}&productIds=${productId}`, { params });
  }

  loadAllUOMCategory(): Observable<any> {
    return this.http.get<any>(`${environment.inventoryURl}Category/GetAllCategoryByGroupName?groupName=UnitOfMeasure`);
  }

}
